import * as angular from "angular";
import {IController} from "angular";

export class vehiclesTableRowCtrl implements IController {

  vehiclesTableCtrl: any;
  defaultVehicleSelectedId: string;
  vehicle: any;

  /* @ngInject */
  constructor() {
  }

}

angular
  .module('bringoz.admin.vehicles')
  .component('vehiclesTableRow', {
    require: {
      vehiclesTableCtrl: '^vehiclesTable'
    },
    bindings: {
      vehicle: '<',
      defaultVehicleSelectedId: '<'
    },
    template: require('./vehicles-table-row.html').default,
    controller: vehiclesTableRowCtrl
  });
